module.exports = __webpack_public_path__ + "static/media/wom-7950-dcto.e0c6d76d.svg";